module.exports = __webpack_public_path__ + "img/nodata.a3a9f069.png";